import { createSlice } from "@reduxjs/toolkit";

const initialCartState = {
  itemId: 0,
  cartTotal: 0,
  fare: 0,
  cart: [],
  user: null,
  parkId: undefined,
  ticketsQuantity: 1,
  showWarning: false,
  showPopup: false,
  ticketsLimit: 5,
  notification: null,
  date: null,
  warningMessage: {
    text: "null",
  },
};

const cartSlice = createSlice({
  name: "cart",
  initialState: initialCartState,
  reducers: {
    addToCart(state, actions) {
      state.cartTotal = 0;
      let n = 0;
      if (state.cart.length > 0) {
        const found = state.cart.find((value, index) => {
          n = index;
          return value.fechaValid === actions.payload.item.fechaValid;
        });
        if (found === undefined) {
          state.cart.push(actions.payload.item);
        } else {
          state.cart[n] = actions.payload.item;
        }
      } else if (state.cart.length <= 0) {
        state.cart.push(actions.payload.item);
      }

      state.cart.map((value) => {
        return (state.cartTotal += value.cantidad * state.fare);
      });
    },
    removeItem(state, actions) {
      state.cartTotal = 0;
      state.cart.splice(actions.payload.id, 1);
      state.cart.map((value) => {
        return (state.cartTotal += value.cantidad * state.fare);
      });
    },
    ticketChange(state, actions) {
      if (actions.payload.quantity < 0) {
        state.warningMessage.text = "Numero invalido de tickets";
        state.showWarning = true;
        document.getElementById("tickets").value = 1;
        state.ticketsQuantity = 1;
      } else {
        if (actions.payload.quantity >= state.ticketsLimit) {
          state.warningMessage.text = "Limite de tickets alcanzado";
          state.showWarning = true;
          document.getElementById("tickets").value = state.ticketsLimit;
          state.ticketsQuantity = state.ticketsLimit;
        } else {
          state.showWarning = false;
          state.ticketsQuantity = actions.payload.quantity;
        }
      }
    },
    setDefaults(state, actions) {
      if (actions.payload.user !== null) {
        switch (actions.payload.user.clientTypeId) {
          case "TO":
            state.ticketsLimit = 600;
            break;
          case "CO":
            state.ticketsLimit = 50;
            break;
          default:
            state.ticketsLimit = 5;
            break;
        }
        switch (actions.payload.user.clientTypeId) {
          case "TO":
            state.fare = actions.payload.park.tarifaParqueExt;
            break;
          case "PP":
            state.fare = actions.payload.park.tarifaParqueExt;
            break;
          default:
            state.fare = actions.payload.park.tarifaParque;
            break;
        }
      } else {
        state.fare = actions.payload.park.tarifaParqueExt;
        state.ticketsLimit = 5;
      }
    },
    toReset(state) {
      Object.assign(state, initialCartState);
    },
  },
});

export const cartActions = cartSlice.actions;
export default cartSlice.reducer;
